import React from 'react';
import { GlobalStyles } from '@mui/material';

/** Shared sizing rules; wide data tables scroll within their own containers. */
export default function ResponsiveStyles() {
  return <GlobalStyles styles={(theme) => ({
    '.workspace-content > *, .workspace-content .MuiGrid-item, .workspace-content .MuiCardContent-root': { minWidth: 0 },
    '.MuiTableContainer-root': { maxWidth: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
    '.MuiTabs-root': { minWidth: 0, maxWidth: '100%' },
    '.MuiAlert-message, .MuiDialogTitle-root': { overflowWrap: 'anywhere' },
    '.MuiInputBase-root': { minWidth: 0 },
    [theme.breakpoints.down('sm')]: {
      '.workspace-content .MuiCardContent-root': { padding: 16, '&:last-child': { paddingBottom: 16 } },
      '.MuiDialog-paper:not(.MuiDialog-paperFullScreen)': { margin: 12, minWidth: 0, width: 'calc(100% - 24px)', maxHeight: 'calc(100dvh - 24px)' },
      '.MuiDialogTitle-root, .MuiDialogContent-root': { paddingLeft: 16, paddingRight: 16 },
      '.MuiDialogActions-root': { flexWrap: 'wrap', gap: 8, padding: 16, '& > *': { margin: '0 !important' } },
      '.MuiButton-root, .MuiIconButton-root, .MuiTab-root, .MuiMenuItem-root': { minHeight: 44 },
      '.MuiIconButton-root': { minWidth: 44 },
      '.MuiInputBase-input': { fontSize: 16 },
      '.MuiTablePagination-toolbar': { flexWrap: 'wrap', paddingLeft: 8, paddingRight: 8, rowGap: 4 },
      '.MuiTablePagination-spacer': { display: 'none' },
      '.MuiTablePagination-actions': { marginLeft: 8 },
      '.MuiTableCell-root': { padding: '12px 10px' },
      '.MuiTab-root': { minWidth: 80, padding: '12px 10px' },
      '.mapboxgl-popup': { maxWidth: 'min(280px, calc(100vw - 40px)) !important' },
      '.mapboxgl-ctrl-group button': { width: 44, height: 44 },
      '.geofence-editor-pin': { width: '44px !important', height: '44px !important' },
      '.mapboxgl-popup-close-button': { minWidth: 44, minHeight: 44 },
    },
  })} />;
}
